import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_APARTMENT_GET_FLOOR_PLANS_BY_APARTMENT_ID,
} from 'api/actionTypes';

export default async function getFloorPlansByApartmentId(
  { state, apiClient },
  { apartmentId },
) {
  typeCheck('apartmentId::Number', apartmentId);

  const statePath = ['apartments', 'floorPlansByApartmentId', apartmentId];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_GET_FLOOR_PLANS_BY_APARTMENT_ID,
    state: state,
    payload: {
      apartmentId: apartmentId,
    },
    onSuccess(floorPlans) {
      if (floorPlans) {
        state.set(statePath, floorPlans);
      }
    },
  });
}
